import React, { useEffect, useState, useRef } from "react";
import PropTypes from "prop-types";
import InputForm from "./InputPassObjects.view";
import { useTranslation } from "react-i18next";

const InputPassObjectsContainer = ({
  objectsPassed,
  objectsPreSelected = [],
  onChange,
  searchField = "batch",
  sortField = "batch",
}) => {
  const { t } = useTranslation();
  const [objects, setObjects] = useState([]);
  const [objectsSelected, setObjectsSelected] = useState([]);
  const [filter, setFilter] = useState("");
  const isInitialized = useRef(false);

  const renderLine = (obj) => {
    return (
      <div className="d-flex justify-content-between">
        <div className="px-3">{`${t("forms.extControl.table.head.batch")}: ${obj.batch}`}</div>
        <div className="px-3">{`${t("forms.expeditionDetail.article")}: ${obj.itemCode}`}</div>
        <div className="px-3">{`${t("forms.items.labels.weight")}: ${obj.weight}KG`}</div>
      </div>
    );
  };

  const arrayOrder = (array, sortBy) => {
    return [...array].sort((a, b) => {
      if (a[sortBy] < b[sortBy]) return -1;
      if (a[sortBy] > b[sortBy]) return 1;
      return 0;
    });
  };

  // Inicialización
  useEffect(() => {
    if (!isInitialized.current && objectsPassed?.length > 0) {
      const preSelected = objectsPreSelected || [];
      const available = objectsPassed.filter(
        (obj) => !preSelected.find((sel) => sel.uuid === obj.uuid),
      );
      setObjects(arrayOrder(available, sortField));
      setObjectsSelected(arrayOrder(preSelected, sortField));
      isInitialized.current = true;
    }
  }, [objectsPassed, objectsPreSelected, sortField]);

  // Notificar cambios
  useEffect(() => {
    if (isInitialized.current && onChange) {
      onChange(objectsSelected);
    }
  }, [objectsSelected, onChange]);

  const handlerOnSelectObjects = (object) => {
    setObjectsSelected(arrayOrder([...objectsSelected, object], sortField));
    setObjects(objects.filter((obj) => obj.uuid !== object.uuid));
    setFilter("");
  };

  const handlerOnSelectAllObjects = () => {
    setObjectsSelected(arrayOrder([...objectsSelected, ...objects], sortField));
    setObjects([]);
    setFilter("");
  };

  const handlerOnDeleteObject = (object) => {
    setObjects(arrayOrder([...objects, object], sortField));
    setObjectsSelected(
      objectsSelected.filter((obj) => obj.uuid !== object.uuid),
    );
  };

  const handlerOnDeleteAllObject = () => {
    setObjects(arrayOrder([...objects, ...objectsSelected], sortField));
    setObjectsSelected([]);
  };

  const filterObjects = (value) => {
    setFilter(value.trim());
  };

  // Filtrar objetos
  const filteredObjects = filter
    ? objects.filter((obj) => {
        // Escapar caracteres especiales de regex
        const escapedFilter = filter.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
        const regex = new RegExp(`^${escapedFilter}`, "i");
        return regex.test(obj[searchField]);
      })
    : objects;

  return (
    <InputForm
      objects={objects}
      objectsSelected={objectsSelected}
      onSelectObject={handlerOnSelectObjects}
      onDeleteObject={handlerOnDeleteObject}
      onSelectAll={handlerOnSelectAllObjects}
      onDeleteAll={handlerOnDeleteAllObject}
      filterObjects={filterObjects}
      objectsBack={filteredObjects}
      filter={filter}
      renderField={renderLine}
    />
  );
};

InputPassObjectsContainer.propTypes = {
  objectsPassed: PropTypes.array.isRequired,
  objectsPreSelected: PropTypes.array,
  onChange: PropTypes.func,
  renderField: PropTypes.func,
  searchField: PropTypes.string,
  sortField: PropTypes.string,
};

export default InputPassObjectsContainer;
